import React from 'react';
import PropTypes from 'prop-types';
/**
 * 버튼 : 아이콘
 */
const FooterButton = ({ icon, styleDef, viewStatus, clickEvt, error, tabIndex }) => {
  return (
    <div className="_at_footer_button_div" style={styleDef} onClick={clickEvt}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      {/* <div className="_button_div" onClick={clickEvt}> */}
      <div className="_button_div" >
        <div className="_icon">
          { icon.length >3 && icon.substring(icon.length-3) && icon.substring(0,2) !== 'ri' ? <img src={`${icon}`} alt={`${icon}`}/> : <i className={icon} style={{ color: styleDef.color }} />}
        </div>
      </div>
    </div>
  );
};

FooterButton.propTypes = {
  icon: PropTypes.string,
  styleDef: PropTypes.object,
  viewStatus: PropTypes.string,
  clickEvt: PropTypes.func,
  error: PropTypes.object,
  tabIndex: PropTypes.number,
};
FooterButton.defaultProps = {
  icon: 'ri-close-fill',
  styleDef: {},
  viewStatus: '',
  clickEvt: () => {},
  error: { error: false, msg: '' },
  tabIndex: 0,
};

export default FooterButton;
